
const SET_IS_CSP_LIST_LOADING = (state, isLoading) => {
  state.isCspListLoading = isLoading;
};

const CSP_LIST_UPDATED = (state, data) => {
  state.cspList = data;
};

// const CSP_LIST = (state, data) => {
//   state.cspList = data;
// };

const SET_SELECTED_VENDOR = (state, vendor) => {
  state.selectedVendor = vendor;
};

export default {

  SET_IS_CSP_LIST_LOADING,
  CSP_LIST_UPDATED,
  // CSP_LIST,

  SET_SELECTED_VENDOR
};




// WEBPACK FOOTER //
// ./src/store/modules/mis-operation-status/csp-operation-status/mutations.js